import $ from "jquery";
import { u_ } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";

vuwer.add("nndPager", {
	selector: "#nnd_pager",
	
	createTemplate() {
		if(this.$self) {
			return $("<div/>").addClass("area-pager nnd-pager");
		}
	},
	
	render($elm, state) {
		if( $elm && state.query && u_.isString(state.query) ) {
			let flg = false;
			const vuwerState = { ...vuwer.getState() };
			
			if( u_.isObject(state.prev) && state.prev.text && state.prev.val ) {
				flg = true;
				vuwerState[state.query] = state.prev.val;
				$("<a/>").addClass("pager-shift change-state").attr({
					"href": `./${u_.createQueryString(vuwerState)}`,
					"target": "_self",
					"data-shift": "prev"
				}).html( $.parseHTML(state.prev.text) ).appendTo($elm);
			}
			
			if( u_.isObject(state.next) && state.next.text ) {
				if(state.next.val) {
					flg = true;
					vuwerState[state.query] = state.next.val;
					$("<a/>").addClass("pager-shift change-state").attr({
						"href": `./${u_.createQueryString(vuwerState)}`,
						"target": "_self",
						"data-shift": "next"
					}).html( $.parseHTML(state.next.text) ).appendTo($elm);
					
				} else
				if(state.next.url) {
					flg = true;
					const reg = new RegExp(`^${RegExp.escape(location.origin)}`);
					$("<a/>").addClass("pager-shift").attr({
						"href": state.next.url,
						"target": reg.test(state.next.url) ? "_self" : "_blank",
						"data-shift": "next"
					}).html( $.parseHTML(state.next.text) ).appendTo($elm);
				}
			}
			
			return flg && $elm;
		}
	}
});
